import { render, staticRenderFns } from "./VxCellResource.vue?vue&type=template&id=6a455e20&"
import script from "./VxCellResource.vue?vue&type=script&lang=js&"
export * from "./VxCellResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports